exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".errorBox[data-v-31eac01e]{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;height:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.errorBox .error[data-v-31eac01e]{text-align:center}.errorBox .error a[data-v-31eac01e]{color:#0f820c;font-size:16px;margin-top:20px}", ""]);

// exports
